export default Object.freeze({
	ADD: `Adding document`,
	CONVERT: `Converting to PDF`,
});